// src/pages/PaymentSuccessPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentSuccessPage({ failed }) {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => navigate('/chat'), 4000);
    return () => clearTimeout(t);
  }, [navigate]);
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: failed ? '#FEF2F2' : '#F0FDF4', padding: 24 }}>
      <div style={{ fontSize: 72, marginBottom: 16 }}>{failed ? '😕' : '🎉'}</div>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: failed ? '#991B1B' : '#166534', marginBottom: 8 }}>
        {failed ? 'Payment Failed' : 'Payment Successful!'}
      </h1>
      <p style={{ color: '#6B7280', textAlign: 'center', marginBottom: 24 }}>
        {failed ? 'Kuch problem aayi. Please dobara try karein.' : 'Aapka plan activate ho gaya! Ab unlimited sawaal poochein.'}
      </p>
      <button onClick={() => navigate('/chat')} style={{ background: '#1E40AF', color: '#FFF', border: 'none', borderRadius: 12, padding: '14px 32px', fontSize: 16, fontWeight: 700, cursor: 'pointer' }}>
        {failed ? 'Dobara Try Karo' : 'Sawaal Poocho 📚'}
      </button>
      <p style={{ color: '#9CA3AF', fontSize: 13, marginTop: 16 }}>Auto-redirecting in 4 seconds...</p>
    </div>
  );
}
